import React from 'react'
import style from './articles.style'

const EcomEnable = ({ classes }) => {
  return (
    <article className={classes.article}>
      <h2>Как включить электронную торговлю</h2>
      <h3>Шаг 1.</h3>
      <ol>
        <li>
          Перейдите в режим <strong>Администратор</strong>
        </li>
        <li>
          Далее в Настройки <strong>электронной торговли</strong>
        </li>
        <figure className={classes.helpArticleFigure}>
          <img src="/images/image2ecom.jpg" alt="true" />
        </figure>
        <li>
          Включите <strong>отслеживание электронной торговли</strong>.
        </li>
        <li>
          Включите <strong>отчеты для расширенной электронной торговли</strong>.
        </li>
        <li>
          Нажмите кнопку <strong>Сохранить</strong>.
        </li>
        <figure className={classes.helpArticleFigure}>
          <img src="/images/image1ecom.jpg" alt="true" />
        </figure>
      </ol>
      <p>Готово!</p>
    </article>
  )
}

export default style(EcomEnable)
